import { AuthService } from './auth.service';

export function authReadyFactory(auth: AuthService): () => Promise<void> {
  return () => auth.waitForAuthReady();
}
